import productService from './productService';

let memoryCache = null;
let fetchPromise = null;

const productCache = {
    /**
     * Tüm ürün listesini çeker veya hafızadan getirir
     * @returns {Promise<Array>} Ürün listesi
     */
    getProducts: async () => {
        if (memoryCache && memoryCache.length > 0) {
            return memoryCache;
        }

        // Önbellekte yoksa sessionStorage kontrol et
        try {
            const sessionData = sessionStorage.getItem('kama_product_cache_v4');
            if (sessionData) {
                const parsed = JSON.parse(sessionData);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    memoryCache = parsed;
                    return memoryCache;
                }
            }
        } catch (e) {
            console.warn('SessionStorage product cache read failed', e);
        }

        // Zaten istek devam ediyorsa aynı promise'i döndür (mükerrer istekleri engeller)
        if (fetchPromise) {
            return fetchPromise;
        }

        fetchPromise = (async () => {
            try {
                const data = await productService.getProducts('*', '0');
                if (Array.isArray(data) && data.length > 0) {
                    memoryCache = data;
                    try {
                        sessionStorage.setItem('kama_product_cache_v4', JSON.stringify(data));
                    } catch (err) {
                        console.warn('SessionStorage quota exceeded', err);
                    }
                }
                return memoryCache || [];
            } catch (error) {
                console.error('Failed to pre-fetch product catalog', error);
                return [];
            } finally {
                fetchPromise = null;
            }
        })();

        return fetchPromise;
    },

    /**
     * Önbelleği zorla yeniler
     */
    refreshCache: async () => {
        memoryCache = null;
        sessionStorage.removeItem('kama_product_cache');
        return productCache.getProducts();
    },

    /**
     * Hafızadaki ürünlerde 0 ms gecikme ile arama yapar
     * @param {string} query - Aranacak kelime veya kod
     * @param {number} limit - Maksimum sonuç sayısı (varsayılan 8)
     * @returns {Promise<Array>} Eşleşen ürünler
     */
    searchLocal: async (query, limit = 10) => {
        if (!query || query.trim().length < 3) return [];

        const allProducts = await productCache.getProducts();
        if (!allProducts || allProducts.length === 0) return [];

        const rawQuery = query.trim().toLowerCase();
        const cleanQuery = rawQuery.replace(/[\s-]/g, '');

        const matches = [];
        for (let i = 0; i < allProducts.length; i++) {
            const p = allProducts[i];
            const orj = (p.OrjinalKodu || '').toLowerCase();
            const kat = (p.KatalogKodu || '').toLowerCase();

            const cleanOrj = orj.replace(/[\s-]/g, '');
            const cleanKat = kat.replace(/[\s-]/g, '');

            if (
                orj.includes(rawQuery) ||
                kat.includes(rawQuery) ||
                cleanOrj.includes(cleanQuery) ||
                cleanKat.includes(cleanQuery)
            ) {
                matches.push(p);
                if (limit > 0 && matches.length >= limit) {
                    break;
                }
            }
        }

        return matches;
    },

    /**
     * Filtrelenmiş tüm ürün sayısını ve listesini döndürür
     */
    filterLocalAll: async (query, model3bOnly = false) => {
        const allProducts = await productCache.getProducts();
        if (!allProducts || allProducts.length === 0) return [];

        if (!query || query === '*') {
            if (model3bOnly) {
                return allProducts.filter(p => p.ModelFile && p.ModelFile.trim() !== '');
            }
            return allProducts;
        }

        const rawQuery = query.trim().toLowerCase();
        const cleanQuery = rawQuery.replace(/[\s-]/g, '');

        return allProducts.filter(p => {
            if (model3bOnly && (!p.ModelFile || p.ModelFile.trim() === '')) {
                return false;
            }

            const orj = (p.OrjinalKodu || '').toLowerCase();
            const kat = (p.KatalogKodu || '').toLowerCase();
            const cleanOrj = orj.replace(/[\s-]/g, '');
            const cleanKat = kat.replace(/[\s-]/g, '');

            return (
                orj.includes(rawQuery) ||
                kat.includes(rawQuery) ||
                cleanOrj.includes(cleanQuery) ||
                cleanKat.includes(cleanQuery)
            );
        });
    }
};

export default productCache;
